// Projektskeden (handlingsskeden) enligt gängse svensk byggprocess.
export interface PhaseDef {
  key: string;
  name: string;
  description: string;
}

export const PHASE_TEMPLATE: PhaseDef[] = [
  {
    key: "program",
    name: "Programskede",
    description: "Behov, förutsättningar och tidiga arbetsmiljörisker utreds.",
  },
  {
    key: "system",
    name: "Systemhandling",
    description: "Tekniska lösningar väljs. Risker som inte kan projekteras bort identifieras.",
  },
  {
    key: "detalj",
    name: "Detaljprojektering",
    description: "Bygghandlingar tas fram. Kvarstående risker beskrivs i arbetsmiljöplanen.",
  },
  {
    key: "upphandling",
    name: "Upphandlingsskede",
    description: "Underlag till entreprenörer, krav på arbetsmiljö förs in i förfrågan.",
  },
  {
    key: "bygg",
    name: "Byggskede",
    description: "Utförandet pågår. Bas-U samordnar, arbetsberedningar och skyddsronder styr.",
  },
  {
    key: "forvaltning",
    name: "Förvaltningsskede",
    description: "Bruksskedet. Dokumentation lämnas över för drift och underhåll.",
  },
];

export const PHASE_STATUS_LABELS: Record<string, string> = {
  planerad: "Planerad",
  pagaende: "Pågående",
  avslutad: "Avslutad",
};

export const DEFERRAL_REASONS: { value: string; label: string }[] = [
  { value: "underlag_saknas", label: "Underlag saknas ännu" },
  { value: "beslut_senare", label: "Beslut tas i senare skede" },
  { value: "entreprenor_svarar", label: "Entreprenören svarar i utförandet" },
  { value: "projektering_pagar", label: "Projekteringen är inte klar" },
  { value: "annat", label: "Annat (beskriv)" },
];

export const phaseName = (key?: string | null): string =>
  PHASE_TEMPLATE.find((p) => p.key === key)?.name ?? (key || "Ej angivet");

export const daysLeft = (due?: string | null): number | null => {
  if (!due) return null;
  const diff = new Date(due).getTime() - new Date().setHours(0, 0, 0, 0);
  return Math.round(diff / 86400000);
};
